import { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { useReactDndConstructs } from '../../../../dnd/ReactDndContext';
import { getDndDesignTokens } from '../../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../../../theme';
import dnd from './DraggableSection.css.json';
import './DraggableSection.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const DraggableSection = props => {
  const dropRef = useRef(null);
  const dragRef = useRef(null);
  const {
    useDrag,
    useDrop,
    getEmptyImage
  } = useReactDndConstructs();
  const [{
    isDragging
  }, drag, preview] = useDrag({
    type: props.dragType,
    item: {
      index: props.index,
      dragType: props.dragType,
      dndPrefix: props.dndPrefix
    },
    canDrag: props.allowDrag,
    options: {
      dropEffect: 'move'
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  const dropAtEnd = monitor => {
    if (dropRef.current && monitor.getClientOffset()) {
      const sectionHeight = dropRef.current.getBoundingClientRect().height;
      const sectionBottom = dropRef.current.getBoundingClientRect().bottom;
      const pointerY = monitor.getClientOffset()?.y ?? 0;
      const diff = sectionBottom - pointerY;
      if (diff <= 0.5 * sectionHeight) return true;else return false;
    }
  };
  const [hoverClass, setHoverClass] = useState('');
  const [{
    isOver,
    canDrop
  }, drop] = useDrop({
    accept: props.allowDropTypes,
    canDrop: () => props.allowDrop,
    hover: (draggedItem, monitor) => {
      let className = '';
      const {
        index: dragIndex,
        dndPrefix: dragDndPrefix
      } = draggedItem ?? {};
      if (monitor.isOver({
        shallow: true
      }) && monitor.canDrop()) {
        if (dragDndPrefix === props.dndPrefix) {
          if (dragIndex < props.index) className = cx(dnd.dropLine, dnd.placeAtEnd);else if (dragIndex > props.index) className = dnd.dropLine;
        } else {
          if (dropAtEnd(monitor) && props.isLastSection) className = cx(dnd.dropLine, dnd.placeAtEnd);else className = dnd.dropLine;
        }
      }
      setHoverClass(className);
    },
    collect: monitor => ({
      isOver: monitor.isOver({
        shallow: true
      }),
      canDrop: monitor.canDrop()
    }),
    drop: (droppedItem, monitor) => {
      if (!monitor.didDrop()) {
        if (droppedItem.dndPrefix === props.dndPrefix) {
          if (droppedItem.index !== props.index) props.onSectionsReorder?.(droppedItem.index, props.index);
        } else {
          const index = props.isLastSection && dropAtEnd(monitor) ? props.index + 1 : props.index;
          const dropTarget = {
            index,
            dragType: props.dragType,
            dndPrefix: props.dndPrefix
          };
          props.onDrop?.({
            monitor,
            dropTarget,
            droppedItem
          });
        }
      }
    }
  });
  useEffect(() => {
    preview(getEmptyImage(), {
      captureDraggingState: true
    });
  });
  drag(dragRef);
  drop(dropRef);
  const dt = useDesignTokens();
  const dndTokens = getDndDesignTokens(dt);
  const draggableClassName = props.allowDrag && !isDragging && dnd.draggable;
  const draggingClassName = isDragging ? dnd.draggedItem : undefined;
  const hoverClassName = isOver && canDrop ? hoverClass : undefined;
  return /*#__PURE__*/_jsx("div", {
    ref: dropRef,
    style: dndTokens,
    className: cx(draggableClassName, hoverClassName),
    children: props.children({
      draggingClassName,
      dragRef
    })
  });
};
//# sourceMappingURL=DraggableSection.js.map